import React, { useEffect } from 'react';
import { Download, X } from 'lucide-react';

type Props = {
  url: string;
  fileName: string;
  title: string;
  onDownload: () => void;
  onClose: () => void;
};

const JobApplicationResumeModal: React.FC<Props> = ({
  url,
  fileName,
  title,
  onDownload,
  onClose,
}) => {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && !e.defaultPrevented) onClose();
    };
    window.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [onClose]);

  return (
    <div className="people-hiring-modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="people-hiring-modal people-hiring-resume-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="hiring-resume-modal-title"
        onClick={e => e.stopPropagation()}
      >
        <div className="people-hiring-modal-header">
          <div>
            <h3 id="hiring-resume-modal-title">{title}</h3>
            <p className="people-hiring-muted" style={{ margin: '4px 0 0' }}>{fileName}</p>
          </div>
          <div className="people-hiring-resume-modal-actions">
            <button type="button" className="pm-btn pm-btn-secondary" onClick={onDownload}>
              <Download size={14} /> Download
            </button>
            <button type="button" className="pm-btn pm-btn-ghost" onClick={onClose} aria-label="Close resume">
              <X size={16} />
            </button>
          </div>
        </div>
        <iframe
          className="people-hiring-resume-frame"
          title={title}
          src={url}
        />
      </div>
    </div>
  );
};

export default JobApplicationResumeModal;
